import { IonContent } from "@ionic/react";
import React from "react";
import { connect } from "react-redux";
import AppHeader from "components/Header/AppHeader";
import QwizardHelp from "./QwizardHelp";

export interface Props {
}

const Help: React.FC<Props> = () => {
  return (
    <>
      <AppHeader title="Help"/>
      <IonContent fullscreen className="ion-padding help">
        <div className="container">
          <QwizardHelp />
        </div>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {})(Help);
